/* eslint-disable */
import { Box, Card, Container, Grid, styled, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import StepProgress from "./StepProgress";
import { validateString } from "../../utils/validations";
import { GENERATE_HEADING, GENERATE_PARAGRAPH, GENERATE_TITLE } from "../../gql/mutations/keyword";
import { usePopup } from "../../context/commonPop";
import { useMutation } from "@apollo/client";
import GenerateKeyword from "./GenerateKeyword";
// import ExploreFeature from "./ExploreFeature";
import { useNavigate } from "react-router";
import { handleTitleGenerate } from "../../utils/blogUtils";

export const SectionWrapper = styled("section")(({ theme }) => ({
    minHeight: "calc(100vh - 64px)",
    backgroundColor: theme.palette.background.default,
    paddingTop: "1px",
    paddingBottom: "80px",

    "& .KeywordIdeasMainHeading": {
        "& h2": { color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547", fontSize: "24px", fontWeight: 700, lineHeight: "1" },
    },
    "& .stepperBox": {
        backgroundColor: theme.palette.mode === "dark" ? "#f5f5f640" : "#F5F5F6",
        padding: "14px",
        borderRadius: "6px",
        backdropFilter: "blur(8px)",
        "@media screen and (max-width:600px)": {
            padding: "10px",
        },
        "& .Mui-completed": {
            "& .MuiStepConnector-line": {
                backgroundColor: theme.palette.primary.main,
                height: "8px",
                marginTop: "3px",
            },
        },
        "& .Mui-active": {
            fill: theme.palette.primary.main,
            "& .MuiStepConnector-line": {
                backgroundColor: theme.palette.primary.main,
                height: "10px",
                marginTop: "3px",
            },
            "& .MuiStepIcon-text": {
                fill: "#fff",
            },
        },
        "& .MuiStepLabel-label": {
            marginTop: "10px",
            "& p": {
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "15.12px",
                color: theme.palette.text.primary,
                "& span": {
                    color: theme.palette.mode === "dark" ? "#fff" : "#808080",
                    fontSize: "12px",
                    fontWeight: 500,
                    lineHeight: "15.12px",
                },
            },
        },
        "& .MuiStepConnector-root": {
            top: "7px",
            left: "calc(-53% + 20px)",
            right: "calc(47% + 20px)",
            height: "15px",
            background: "#fff",
            zIndex: "0",
            "& span": {
                border: "none",
            },
        },
        "& .Mui-completed svg": {
            fill: `${theme.palette.primary.main} !important`,
            color: "#fff",
            padding: "0px",
            overflow: "hidden",
            "& .MuiStepIcon-text": {
                fill: "#2A3547",
            },
        },
        "& .MuiSvgIcon-root": {
            fontWeight: 800,
            lineHeight: "17.64px",
            fill: "#F5F5F6",
            "& .MuiStepIcon-text": {
                fill: "#2A3547",
            },
            "&.Mui-active": {
                fill: theme.palette.primary.main,
                "& .MuiStepConnector-line": {
                    borderColor: theme.palette.primary.main,
                    backgroundColor: theme.palette.primary.main,
                    height: "10px",
                    marginTop: "3px",
                },
                "& .MuiStepIcon-text": {
                    fill: "#fff",
                },
            },
        },
        "& .MuiStepLabel-iconContainer": {
            border: "3px solid #fff",
            borderRadius: "50%",
            position: "relative",
            zIndex: 1,
        },
    },
    "& .GenerateKeywordBox": {
        backgroundColor: theme.palette.mode === "dark" ? "transparent" : "#EBF9FA66",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "30px",
        padding: "20px",
        marginTop: "20px",
        "& .rankingContent": {
            "& h2": {
                fontSize: "20px",
                fontWeight: 700,
                lineHeight: "25.2px",
                textAlign: "center",
                color: theme.palette.text.primary,
                marginBottom: "6px",
            },
            "& p": {
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: "17.64px",
                textAlign: "center",
                color: theme.palette.text.primary,
            },
        },
        "& .KeywordInputBoxes": {
            display: "flex",
            justifyContent: "center",
            gap: "14px",
            flexWrap: "wrap",
            width: "100%",
            alignItems: "end",
            "& .inputBox": {
                flex: 1,
                display: "flex",
                flexDirection: "column",
                gap: "6px",
                "& label": {
                    fontSize: "12px",
                    fontWeight: 500,
                    lineHeight: "15.12px",
                    textAlign: "left",
                    color: theme.palette.text.primary,
                },
                "& .inputField": {
                    minWidth: 200,
                    width: "100%",
                    "& fieldset": {
                        display: "none",
                    },
                    "& input": {
                        border: `1px solid ${theme.palette.text.primary}`,
                        borderRadius: "6px",
                        color: "#808080",
                    },
                },
            },
        },
        "& .SelectInputBoxes": {
            display: "flex",
            flexDirection: "column",
            gap: "6px",
            "@media screen and (max-width:600px)": {
                width: "100%",
            },
            "& label": {
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "15.12px",
                textAlign: "left",
                color: theme.palette.text.primary,
            },
            "& .selectBox": {
                "& fieldset": {
                    display: "none",
                },
                border: `1px solid ${theme.palette.text.primary}`,
                borderRadius: "6px",
                color: "#808080",
            },
        },
        "& .GenerateBtn": {
            height: "44px",
            backgroundColor: theme.palette.primary.main,
            color: "#fff  ",
            width: "93.11px",
            "@media screen and (max-width:600px)": {
                width: "100%",
            },
            "&:hover": {
                backgroundColor: theme.palette.primary.dark,
            },
            "&:focus": {
                outline: "0",
            },
            "&.Mui-disabled": {
                opacity: "0.3",
            },
            "& .loaderBox": {
                height: "25px !important",
                width: "25px !important",
                color: "#fff",
            },
        },
    },
    "& .exploreFeature": {
        marginTop: "20px",
        "& .mainHeading": {
            fontSize: "20px",
            fontWeight: 700,
            lineHeight: "25.2px",
            textAlign: "center",
            color: theme.palette.text.primary,
            marginBottom: "20px",
        },
        "& .featureBoxes": {
            display: "flex",
            alignItems: "center",
            gap: "16px",
            padding: "36px 32px",
            borderRadius: "6px",
            backgroundColor: theme.palette.primary.light,
            border: "1px solid #4DC0FF",
            "@media screen and (max-width:600px)": {
                padding: "20px 20px",
            },
            "& .featureDescription": {
                "& h3": {
                    fontSize: "18px",
                    fontWeight: 700,
                    lineHeight: "22.68px",
                    color: theme.palette.text.primary,
                    marginBottom: "4px",
                },
                "& p": {
                    fontSize: "12px",
                    fontWeight: 600,
                    lineHeight: "15.12px",
                    textAlign: "left",
                    color: theme.palette.mode === "dark" ? "#fff" : "#808080",
                },
            },
        },
        "& .nextBtn": {
            marginTop: "20px",
            textAlign: "right",
            "& button": {
                backgroundColor: theme.palette.primary.main,
                color: "#fff",
                "&:hover": {
                    backgroundColor: theme.palette.primary.dark,
                },

                "&:focus": {
                    outline: "0",
                },
                "&.Mui-disabled": {
                    color: "#ffffff52",
                },
            },
        },
    },
    "& .BestRepresent": {
        "& .representsHeading": {
            fontSize: "20px",
            fontWeight: 700,
            lineHeight: "25.2px",
            textAlign: "center",
            color: theme.palette.text.primary,
            marginBottom: "20px",
        },
        "& .representContentBox": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            border: "1px solid #E3E3E3",
            marginBottom: "14px",
            padding: "14px",
            borderRadius: "6px",
            gap: "10px",
            "& .InnerContent": {
                display: "flex",
                gap: "8px",
                alignItems: "self-start",
                "& .radioBtn": {
                    padding: 0,
                },
                "& .radioGroupBox": {
                    margin: "0",
                    alignItems: "start",
                    gap: "8px",
                },
                "& h3": {
                    fontSize: "16px",
                    fontWeight: 700,
                    lineHeight: "20.16px",
                    textAlign: "left",
                    color: theme.palette.text.primary,
                    marginBottom: "6px",
                    "& span": {
                        color: "#2A3547",
                    },
                },
                "& p": {
                    fontSize: "12px",
                    fontWeight: 400,
                    lineHeight: "15.12px",
                    textAlign: "left",
                    color: theme.palette.mode === "dark" ? "#fff" : "#808080",
                },
            },
            "& .editBtn": {
                background: "transparent",
                padding: "0",
                minWidth: "39px",
                "&:focus": {
                    outline: "none",
                },
            },
        },
        "& .BtnGroup": {
            display: "flex",
            justifyContent: "center",
            gap: "16px",
            marginTop: "27px",
            textAlign: "center",
            "&.Mui-disabled": {
                opacity: "0.3",
            },
            "@media screen and (max-width:600px)": {
                flexDirection: "column",
            },
            "& .moreTitle": {
                border: `1px solid ${theme.palette.primary.main}`,
                color: theme.palette.primary.main,
                backgroundColor: "transparent",
                padding: "12px 28px",
                fontSize: "14px",
                fontWeight: 600,
                lineHeight: "17.64px",
                minWidth: "205px",
                "&:hover": {
                    backgroundColor: theme.palette.primary.dark,
                    color: "#fff",
                    "& svg": {
                        fill: "#fff",
                    },
                },

                "&:focus": {
                    outline: "none",
                },
                "&.Mui-disabled": {
                    opacity: "0.3",
                },
                "& svg": {
                    fill: theme.palette.primary.main,
                    marginRight: "8px",
                },
                "& .MuiCircularProgress-root": {
                    "& svg": {
                        marginRight: "0",
                    },
                },
            },
        },
        "& .BottomBtnGroup": {
            display: "flex",
            justifyContent: "space-between",
            marginTop: "124px",
            gap: "20px",
            "@media screen and (max-width:600px)": {
                flexDirection: "column",
                marginTop: "20px",
            },
            "& .BackBtn": {
                border: `1px solid ${theme.palette.primary.main}`,
                color: theme.palette.primary.main,
                backgroundColor: "transparent",
                padding: "12px 28px",
                fontSize: "14px",
                fontWeight: 600,
                lineHeight: "17.64px",
                "&:hover": {
                    backgroundColor: theme.palette.primary.dark,
                    color: "#fff",
                },

                "&:focus": {
                    outline: "0",
                },
                "&.Mui-disabled": {
                    opacity: "0.3",
                },
            },
            "& .generateIntro": {
                padding: "12px 28px",
                fontSize: "14px",
                fontWeight: 600,
                lineHeight: "17.64px",
                backgroundColor: theme.palette.primary.main,
                color: "#fff",
                minWidth: "230px",
                "&:hover": {
                    backgroundColor: theme.palette.primary.dark,
                    color: "#fff",
                },
                "&:focus": {
                    outline: "0",
                },
                "&.Mui-disabled": {
                    opacity: "0.3",
                },
                "& .MuiCircularProgress-root": {
                    "& svg": {
                        color: "#ffffff",
                    },
                },
            },
        },
    },
    "& .IntroParagraph": {
        "& .representsHeading": {
            fontSize: "20px",
            fontWeight: 700,
            lineHeight: "25.2px",
            textAlign: "center",
            color: theme.palette.text.primary,
            marginBottom: "20px",
        },
        "& .representContentBox": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            border: "1px solid #E3E3E3",
            marginBottom: "14px",
            padding: "14px",
            borderRadius: "6px",
            gap: "10px",
            "& .InnerContent": {
                display: "flex",
                gap: "8px",
                alignItems: "self-start",
                "& .radioGroupBox": {
                    alignItems: "start",
                    gap: "8px",
                    margin: "0",
                },
                "& .radioBtn": {
                    padding: 0,
                },
                "& h3": {
                    fontSize: "16px",
                    fontWeight: 700,
                    lineHeight: "20.16px",
                    textAlign: "left",
                    color: theme.palette.text.primary,
                    marginBottom: "6px",
                    "& span": {
                        color: "#2A3547",
                    },
                },
                "& p": {
                    fontSize: "12px",
                    fontWeight: 400,
                    lineHeight: "15.12px",
                    textAlign: "left",
                    color: theme.palette.mode === "dark" ? "#fff" : "#808080",
                },
            },
            "& .editBtn": {
                background: "transparent",
                padding: "0",
                minWidth: "39px",
                "&:focus": {
                    outline: "none",
                },
            },
        },
        "& .BtnGroup": {
            display: "flex",
            justifyContent: "center",
            gap: "16px",
            marginTop: "27px",
            textAlign: "center",
            "@media screen and (max-width:600px)": {
                flexDirection: "column",
            },
            "& .moreTitle": {
                border: `1px solid ${theme.palette.primary.main}`,
                color: theme.palette.primary.main,
                backgroundColor: "transparent",
                padding: "12px 28px",
                fontSize: "14px",
                fontWeight: 600,
                lineHeight: "17.64px",
                minWidth: "205px",
                "&:hover": {
                    backgroundColor: theme.palette.primary.dark,
                    color: "#fff",
                    "& svg": {
                        fill: "#fff",
                    },
                },
                "&:focus": {
                    outline: "none",
                },
                "&.Mui-disabled": {
                    opacity: "0.3",
                },
                "& svg": {
                    fill: theme.palette.primary.main,
                    marginRight: "8px",
                },
                "& .MuiCircularProgress-root": {
                    "& svg": {
                        marginRight: "0",
                    },
                },
            },
        },
        "& .BottomBtnGroup": {
            display: "flex",
            justifyContent: "space-between",
            marginTop: "124px",
            gap: "20px",
            "@media screen and (max-width:600px)": {
                flexDirection: "column",
                marginTop: "20px",
            },
            "& .BackBtn": {
                border: `1px solid ${theme.palette.primary.main}`,
                color: theme.palette.primary.main,
                backgroundColor: "transparent",
                padding: "12px 28px",
                fontSize: "14px",
                fontWeight: 600,
                lineHeight: "17.64px",
                "&:hover": {
                    backgroundColor: theme.palette.primary.dark,
                    color: "#fff",
                },
                "&:focus": {
                    outline: "0",
                },
                "&.Mui-disabled": {
                    opacity: "0.3",
                },
            },
            "& .generateIntro": {
                padding: "12px 28px",
                fontSize: "14px",
                fontWeight: 600,
                lineHeight: "17.64px",
                backgroundColor: theme.palette.primary.main,
                color: "#fff",
                minWidth: "205px",
                "&:hover": {
                    backgroundColor: theme.palette.primary.dark,
                    color: "#fff",
                },
                "&:focus": {
                    outline: "0",
                },
                "&.Mui-disabled": {
                    opacity: "0.3",
                },
                "& .MuiCircularProgress-root": {
                    "& svg": {
                        color: "#ffffff",
                    },
                },
            },
        },
    },
    "& .representsPage": {
        "& .representsHeading": {
            fontSize: "20px",
            fontWeight: 700,
            lineHeight: "25.2px",
            textAlign: "center",
            color: theme.palette.text.primary,
        },
        "& .representTopBox": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "30px",
            "@media screen and (max-width:600px)": {
                flexDirection: "column",
                gap: "20px",
            },
        },
        "& .BtnGroup": {
            display: "flex",
            justifyContent: "center",
            gap: "16px",
            textAlign: "center",
            "@media screen and (max-width:600px)": {
                flexDirection: "column",
            },
            "& .moreTitle": {
                border: `1px solid ${theme.palette.primary.main}`,
                color: theme.palette.primary.main,
                backgroundColor: "transparent",
                padding: "12px 28px",
                fontSize: "14px",
                fontWeight: 600,
                lineHeight: "17.64px",
                "&:hover": {
                    backgroundColor: theme.palette.primary.dark,
                    color: "#fff",
                    "& svg": {
                        fill: "#fff",
                    },
                },
                "&:focus": {
                    outline: "0",
                },
                "&.Mui-disabled": {
                    color: "#ffffff52",
                },
                "& svg": {
                    fill: theme.palette.primary.main,
                    marginRight: "8px",
                },
            },
        },
    },
    "& .fourthStep": {
        "& .welcomeCardBox": {
            display: "none",
        },
        "& .showCompleteContent": {
            display: "none",
        },
        "& section .MuiContainer-root": {
            padding: 0,
        },
    },
    "& .BottomBtnGroup": {
        marginTop: "124px",
        "@media screen and (max-width:600px)": {
            marginTop: "20px",
        },
        "& .BackBtn": {
            border: `1px solid ${theme.palette.primary.main}`,
            color: theme.palette.primary.main,
            backgroundColor: "transparent",
            padding: "12px 28px",
            fontSize: "14px",
            fontWeight: 600,
            lineHeight: "17.64px",
            "@media screen and (max-width:600px)": {
                width: "100%",
            },
            "&:hover": {
                backgroundColor: theme.palette.primary.dark,
                color: "#fff",
            },
            "&:focus": {
                outline: "0",
            },
        },
    },
}));

const AiBlogWriter = () => {
    const navigate = useNavigate();
    const [formState, setFormState] = useState({
        keyword: "",
        selectedTitle: "",
        selectedParagraph: "",
        language: "English",
        count: 1,
        loading: false,
        isCheckedTitle: true,
        isCheckedParagraph: true,
    });
    const [errorState, setErrorState] = useState({
        keyword: false,
    });
    const theme = useTheme();
    const [activeStep, setActiveStep] = useState(0);
    const [titles, setTitles] = useState([]);
    const [paragraph, setParagraph] = useState([]);
    const [heading, setHeading] = useState([]);
    const { handleOpen } = usePopup();
    const [generateTitle] = useMutation(GENERATE_TITLE);
    const [generateParagraph] = useMutation(GENERATE_PARAGRAPH);
    const [generateHeading] = useMutation(GENERATE_HEADING);

    const checkError = async () => {
        const keyword = validateString(formState.keyword);
        setErrorState({
            ...errorState,
            keyword,
        });
        if (keyword) {
            return true;
        }
        return false;
    };

    const handleState = () => {
        setFormState({ keyword: "", language: "English", count: 1, loading: false });
    };
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <SectionWrapper>
            <Container maxWidth="">
                <Box sx={{ flexGrow: 1 }}>
                    <Card sx={{ padding: "18px 14px 18px 14px", border: `1px solid ${theme.palette.divider}`, boxShadow: "none !important", overflow: "visible" }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sx={{ position: "sticky", left: "0", top: { xs: "42px", sm: "47px", lg: "53px" }, zIndex: 999999 }}>
                                <StepProgress activeStep={activeStep} formState={formState} />
                            </Grid>
                            <Grid item xs={12}>
                                <GenerateKeyword
                                    setFormState={setFormState}
                                    formState={formState}
                                    errorState={errorState}
                                    setErrorState={setErrorState}
                                    generateTitle={generateTitle}
                                    titles={titles}
                                    handleTitleGenerate={handleTitleGenerate}
                                    setTitles={setTitles}
                                    setActiveStep={setActiveStep}
                                    handleOpen={handleOpen}
                                    checkError={checkError}
                                    handleState={handleState}
                                    navigate={navigate}
                                />
                                {/* <ExploreFeature titles={titles} setActiveStep={setActiveStep} /> */}
                            </Grid>
                        </Grid>
                    </Card>
                </Box>
            </Container>
        </SectionWrapper>
    );
};

export default AiBlogWriter;
